export default {
  headline: 'Predplatné používateľov',
  subheadline: 'Konfigurácia notifikačných služieb používateľa',
  noUserSelected: 'Prosím vyberte používateľa',
};
